import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";
const getAllSimPackage = ({
  lang,
  page,
  perPage,
  search,
  sortBy,
  sortByOrder,
  filters = {},
}) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      lang,
      page,
      perPage,
      searchTerm: search || "",
      sortByCol: sortBy,
      sortByOrder,
    });

    if (filters.vendor) params.set("vendor", filters.vendor);
    if (filters.days) params.set("days", filters.days);
    if (filters.data) params.set("data", filters.data);
    if (filters.isFree) params.set("isFree", filters.isFree);
    if (filters.isUnlimited) {
      params.set("isUnlimited", filters.isUnlimited);
    }

    const URL = `${routes.GET_ALL_SIM_PACKAGE}?${params.toString()}`;
    axios
      .get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getAllSimPackage;
